import { approveBroadcastedMessageHandler } from '../../../../components/Portal/helpers';
import { useTranslation } from 'react-i18next';
import { useEffect, useRef } from 'react';
import { mainMenuLinks } from './constants';
import { useSelector, useDispatch } from 'react-redux';
import { actionTypes } from '../../constants';
import localStorageHelper from 'helpers/localStorageHelper';


const useModalOptions = (setModalVisible, setCurrentModal, acceptActions, closeModal) => {
    const { t: translate } = useTranslation();
    const modalOptions = useRef([]);
    const dispatch = useDispatch();
    const isEULAAccepted = useSelector((state) => state.overview.user?.data?.isEULAAccepted);
    const broadcastMessagesInfo = useSelector((state) => state.overview.getBroadcastMessagesView?.data);
    const userId = useSelector((state) => state.overview.user?.data?.userID);
    const broadcastMessageId = broadcastMessagesInfo?.length > 0 ? broadcastMessagesInfo[0]?.broadcastMessageId : null;

    const showEulaFunction = () => {
        setCurrentModal({
            modalType: 'eula',
            modalMetadata: {
                link: mainMenuLinks.eula,
                closeOnAcceptOnly: true,
                persistent: true,
                acceptButtonProps: {
                    text: translate('ABB.Powertrain.Frontend.acceptButton'),
                    onClick: () => {
                        acceptActions.EULA();
                        closeModal();
                    }
                }
            }
        });
    };

    const showBroadcastMessageFunction = (broadcastedMessage) => {
        const pdfPath = broadcastedMessage[0]?.pdfPath;

        if (!pdfPath) {
            return false;
        }

        setCurrentModal({
            modalType: 'approveOnlyBroadcastPDF',
            modalMetadata: {
                broadcastedMessagePath: pdfPath,
                acceptButtonProps: {
                    text: translate('ABB.Powertrain.Frontend.acknowledgeButton'),
                    onClick: () => {
                        approveBroadcastedMessageHandler(broadcastedMessage[0]?.broadcastMessageId, userId);
                        dispatch({ type: actionTypes.BROADCAST_INFO_ACKNOWLEDGED });
                        const user = localStorageHelper.getItem('user');
                        if (user) {
                            localStorageHelper.setItem('user', { ...user, broadcastMessageID: null });
                        }
                        closeModal();
                    }
                }
            }
        });
        return true;
    };


    useEffect(() => {
        const showEula = isEULAAccepted !== undefined && !isEULAAccepted;
        const showBroadcastMessage = broadcastMessageId;

        if (showEula) {
            setModalVisible(true);
            showEulaFunction();
        } else if (showBroadcastMessage) {
            const modalSet = showBroadcastMessageFunction(broadcastMessagesInfo);
            if (modalSet) {
                setModalVisible(true);
            }
        }
    }, [isEULAAccepted, broadcastMessageId]);

    return modalOptions.current;
};

export default useModalOptions;
